import React, { useState } from "react";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import RootState from "../../../redux/states/root.state";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { deleteDealership } from "../../../redux/actions/dealership.actions";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";


const DeleteDealershipModal: React.FC<ModalProps> = ({open, setOpen, object}) => {
  const dealership = object;
  const dispatch: AppDispatch = useDispatch();
  const {loading, error} = useSelector((state: RootState) => state.dealership);
  const [submitted, setSubmitted] = useState(false);

  const handleClose = () => {
    setSubmitted(false);
    setOpen(false);
  };

  const handleDelete = async () => {
    setSubmitted(true);
    await dispatch(deleteDealership(dealership?.id));
  };

  const done = !loading && Boolean(error || submitted);

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={loading && submitted}
      tone={loading ? undefined : error ? "error" : submitted ? "success" : "warning"}
      title={
        loading && !submitted ? "Loading…"
        : loading && submitted ? "Deleting…"
        : error ? "An error occurred"
        : submitted ? "Dealership deleted"
        : <>Delete <strong>{dealership?.name}</strong>?</>
      }
      actions={loading ? undefined : done ?
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
        :
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete}>Delete</button>
        </>
      }
    >
      {loading ?
        <ModalLoading/>
        : error ?
        <p>{error}</p>
        : submitted ?
        <p>Dealership successfully deleted.</p>
        :
        <p>This action cannot be undone.</p>
      }
    </ModalShell>
  );
};

export default DeleteDealershipModal;
